import React, { useState } from "react";
import { FoBars, FoCard, FoKpis, formatEgp } from "./financeUi";
import { os } from "./osClient";
import { SelectField, useOsResource } from "./osForm";
import { monthBounds } from "./osRules";

const monthChoices = ["3", "6", "12", "24"];

export default function TransactionAnalysis() {
  const [months, setMonths] = useState("6");
  const [downloading, setDownloading] = useState("");
  const view = useOsResource((auth) => os.analysis(auth, months), [months]);
  const series = view.data?.months || [];
  const totals = view.data?.totals || {};
  const bounds = monthBounds(series);

  const download = async (format) => {
    setDownloading(format);
    try {
      await os.downloadReport(view.token, "profit-and-loss", { format, ...bounds });
    } catch (err) {
      /* toast already shown */
    } finally {
      setDownloading("");
    }
  };

  return (
    <div className="fo-stack">
      <div className="fo-tools">
        <SelectField label="Months" value={months} onChange={setMonths} options={monthChoices.map((value) => ({ value, label: `${value} months` }))} />
        <button type="button" className="fo-btn" disabled={!series.length || downloading !== ""} onClick={() => download("pdf")}>P&L PDF</button>
        <button type="button" className="fo-btn" disabled={!series.length || downloading !== ""} onClick={() => download("xlsx")}>P&L spreadsheet</button>
      </div>
      <FoKpis
        items={[
          { label: "Revenue", value: `${formatEgp(totals.revenue)} EGP`, note: "Fulfillment fees and shipping surcharges" },
          { label: "Expenses", value: `${formatEgp(totals.expenses)} EGP`, note: "Company expense ledger" },
          { label: "Net", value: `${formatEgp(totals.net)} EGP` },
          { label: "Margin", value: `${totals.margin || 0}%` },
        ]}
      />
      <FoCard title="Revenue and expenses" note="Revenue is Chainz income. Expenses are the company ledger, not brand fees. The download is the profit and loss report for this chart range.">
        <div className="fo-legend">
          <span><i /> Revenue</span>
          <span><i className="exp" /> Expenses</span>
        </div>
        <FoBars months={series} />
      </FoCard>
    </div>
  );
}
